import {
  apiUrlWithParams,
  authBinaryFetch,
  authFetch,
  convertToJson,
  createForm,
  getLocale,
  jsonFetch,
  nullToEmptyString,
  removeEmptyFields,
} from "utils";
import { createUrlParams } from "utils/urlParams";

export const getCurrentUser = () =>
  authFetch(`${apiUrl}${version}/users/current_user`, {
    method: "GET",
  });

export const inviteUser = (user, assetIDs) =>
  authFetch(`${apiUrl}${version}/users/invite_user`, {
    method: "POST",
    json: { user: removeEmptyFields(user), assetIDs },
  });

export const getCurrentUserByToken = (email, token) =>
  jsonFetch(
    `${apiUrl}${version}/users/current_user${createUrlParams({
      email,
      token,
    })}`,
    {
      method: "GET",
    }
  );

export const confirmUser = (user) =>
  authBinaryFetch(`${apiUrl}${version}/users/invited_user`, {
    method: "POST",
    body: createForm({ user: nullToEmptyString(user) }),
  }).then((res) => convertToJson(res));

export const requestPasswordReset = (email) =>
  jsonFetch(`${apiUrl}${version}/users/password`, {
    method: "POST",
    json: { user: { email }, locale: getLocale() },
  });

export const resetPassword = (params) =>
  jsonFetch(`${apiUrl}${version}/users/password`, {
    method: "PUT",
    json: { token: params.token, user: params },
  });

export const updatePassword = (user) =>
  authFetch(`${apiUrl}${version}/users/update_password`, {
    method: "PUT",
    json: user,
  });

export const saveUser = (user) =>
  authBinaryFetch(`${apiUrl}${version}/users`, {
    method: "PUT",
    body: createForm(user),
  }).then((res) => convertToJson(res));

export const deleteUser = (user) =>
  authFetch(`${apiUrl}${version}/users/${user.id}`, {
    method: "DELETE",
  });

export const registerUser = (user, params) =>
  jsonFetch(apiUrlWithParams(`${apiUrl}${version}/users`, params), {
    method: "POST",
    json: user,
  });

export default getCurrentUser;
